export default __webpack_public_path__ + "media/components/Header/Images/Schema_blue-7c2c327fddd373dc1873b4e91fb3d252.svg";